// extracted by mini-css-extract-plugin
export default {"moreButton":"CustomerList_moreButton__axhw6","row":"CustomerList_row__vsI5T","pointer":"CustomerList_pointer__6wivd","tableHeader":"CustomerList_tableHeader__A7li2"};